import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceModelsService {
  constructor(private httpClient: HttpClient) {}

  list() {
    return this.httpClient.get('device_models/');
  }
}
